import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';
import {CommonModule} from '@angular/common';
import {NzInputModule} from 'ng-zorro-antd/input';
import {ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'zorrly-textarea',
  standalone: true,
  imports: [
    CommonModule,
    NzInputModule,
    ReactiveFormsModule
  ],
  template: `
      <textarea rows="4" nz-input [formControl]="$any(formControl)"></textarea>
  `,
})
export class ZorrlyTextareaComponent extends FieldType {
}
